const EMPTY_NUMERIC_VALUES = new Set(['', '-', '.', '-.']);

export const parseNGXMaskToNumber = (value: string | null | undefined): number | null => {
    if (value === null || value === undefined) {
        return null;
    }
    const cleaned = String(value)
        .replace(/,/g, '.')
        .replace(/[^0-9.-]+/g, '');
    if (EMPTY_NUMERIC_VALUES.has(cleaned)) {
        return null;
    }
    const parsed = Number(cleaned);
    return Number.isFinite(parsed) ? parsed : null;
};
